(function () {
  'use strict';

  // ── Config ─────────────────────────────────────────────────────────────────
  var DROP_DATE        = '2025-05-28T12:00:00';
  var COOKIE_NAME      = 'dg_access';
  var COOKIE_DAYS      = 365;
  var KLAVIYO_URL      = 'https://a.klaviyo.com/client/subscriptions/';
  // 2024-10-15 rejects the `subscriptions` consent field — keep >= 2025-04-15
  var KLAVIYO_REVISION = '2025-04-15';

  // ── Helpers ────────────────────────────────────────────────────────────────

  function getCookie(name) {
    var m = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return m ? m[2] : null;
  }

  function setCookie(name, value, days) {
    var exp = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + '=' + value + '; expires=' + exp + '; path=/; SameSite=Lax';
  }

  function formatPhone(raw) {
    var digits = raw.replace(/\D/g, '');
    if (raw.trim().startsWith('+')) return '+' + digits;
    if (digits.length === 11 && digits.charAt(0) === '1') return '+' + digits;
    if (digits.length === 10) return '+1' + digits;
    return '+' + digits;
  }

  function pad(n) { return String(n).padStart(2, '0'); }

  // Klaviyo Client API: subscribe a profile (202 + empty body on success)
  function klaviyoSubscribe(profileAttributes, targetListId) {
    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'DG Password Gate',
          profile: { data: { type: 'profile', attributes: profileAttributes } },
        },
      },
    };
    if (targetListId) {
      body.data.relationships = { list: { data: { type: 'list', id: targetListId } } };
    }
    return fetch(KLAVIYO_URL + '?company_id=' + encodeURIComponent(publicKey), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: KLAVIYO_REVISION },
      body: JSON.stringify(body),
    })
      .then(function (res) {
        if (!res.ok) {
          return res.text().then(function (text) {
            console.error('[DG Gate] Klaviyo API error ' + res.status + ':', text);
          });
        }
      })
      .catch(function (err) {
        console.error('[DG Gate] Klaviyo request failed:', err.message || err);
      });
  }

  function klaviyoPush(args) {
    window.klaviyo = window.klaviyo || [];
    window.klaviyo.push(args);
  }

  function gtagEvent(name) {
    if (typeof gtag === 'function') gtag('event', name);
  }

  function makeCopyHandler(btnId) {
    var btn = document.getElementById(btnId);
    if (!btn) return;
    btn.addEventListener('click', function () {
      navigator.clipboard.writeText('DIRTYGAME15').then(function () {
        btn.textContent = 'Copied!';
        setTimeout(function () { btn.textContent = 'Copy'; }, 2000);
      }).catch(function () {
        btn.textContent = 'DIRTYGAME15';
      });
    });
  }

  // ── DOM refs ───────────────────────────────────────────────────────────────

  var config    = document.getElementById('pg-config');
  var publicKey = config ? (config.dataset.publicKey || '') : '';
  var listId    = config ? (config.dataset.listId || '') : '';
  var smsListId = config ? (config.dataset.smsListId || '') : '';

  var step1     = document.getElementById('pg-step-1');
  var step2     = document.getElementById('pg-step-2');
  var success   = document.getElementById('pg-success');
  var dots      = document.getElementById('pg-dots');
  var dot1      = document.getElementById('pg-dot-1');
  var dot2      = document.getElementById('pg-dot-2');

  var nameInput  = document.getElementById('pg-name');
  var emailInput = document.getElementById('pg-email');
  var phoneInput = document.getElementById('pg-phone');
  var btn1       = document.getElementById('pg-btn-1');
  var btn2       = document.getElementById('pg-btn-2');
  var skipBtn    = document.getElementById('pg-skip');
  var err1       = document.getElementById('pg-err-1');
  var err2       = document.getElementById('pg-err-2');

  var vipToggle  = document.getElementById('pg-vip-toggle');
  var vipWrap    = document.getElementById('pg-vip-wrap');

  // ── Countdown ──────────────────────────────────────────────────────────────

  function startCountdown() {
    var target = new Date(DROP_DATE).getTime();
    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) { ['cd-days','cd-hours','cd-mins','cd-secs'].forEach(function(id){ var el=document.getElementById(id); if(el) el.textContent='00'; }); return; }
      var d=Math.floor(diff/86400000), h=Math.floor((diff%86400000)/3600000), m=Math.floor((diff%3600000)/60000), s=Math.floor((diff%60000)/1000);
      var days=document.getElementById('cd-days'), hours=document.getElementById('cd-hours'), mins=document.getElementById('cd-mins'), secs=document.getElementById('cd-secs');
      if(days) days.textContent=pad(d); if(hours) hours.textContent=pad(h); if(mins) mins.textContent=pad(m); if(secs) secs.textContent=pad(s);
    }
    tick();
    setInterval(tick, 1000);
  }

  // ── Show success ───────────────────────────────────────────────────────────

  function showSuccess() {
    if (step2)  step2.classList.add('is-hidden');
    if (dots)   dots.style.display = 'none';
    if (success) {
      success.classList.remove('is-hidden');
      success.classList.add('is-entering');
    }
    startCountdown();
    makeCopyHandler('pg-copy-btn-2');
  }

  // ── Returning visitor ──────────────────────────────────────────────────────

  if (getCookie(COOKIE_NAME) === '1') {
    if (step1)  step1.classList.add('is-hidden');
    if (dots)   dots.style.display = 'none';
    if (success) success.classList.remove('is-hidden');
    startCountdown();
    makeCopyHandler('pg-copy-btn-2');
  } else {
    gtagEvent('gate_viewed');
  }

  // ── Step 1: Email → reveal discount + phone ask ────────────────────────────

  function handleStep1() {
    var name  = nameInput  ? nameInput.value.trim()  : '';
    var email = emailInput ? emailInput.value.trim() : '';
    if (err1) err1.textContent = '';

    if (!name)                        { if (err1) err1.textContent = 'Enter your first name.';        return; }
    if (!email || !email.includes('@')) { if (err1) err1.textContent = 'Enter a valid email address.'; return; }

    if (btn1) { btn1.disabled = true; btn1.textContent = '—'; }

    gtagEvent('gate_step1_submitted');
    setCookie(COOKIE_NAME, '1', COOKIE_DAYS);

    function doTransition() {
      step1.classList.add('is-exiting');
      setTimeout(function () {
        step1.classList.add('is-hidden');
        step1.classList.remove('is-exiting');
        step2.classList.remove('is-hidden');
        step2.classList.add('is-entering');
        if (dot1) dot1.classList.remove('is-active');
        if (dot2) dot2.classList.add('is-active');
        makeCopyHandler('pg-copy-btn');
        if (phoneInput) phoneInput.focus();
      }, 340);
    }

    klaviyoPush(['identify', { $email: email, $first_name: name }]);
    klaviyoPush(['track', 'Gate Email Submitted']);

    window._pgEmail = email;
    window._pgName  = name;

    if (publicKey) {
      klaviyoSubscribe({
        email: email,
        first_name: name,
        subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
      }, listId).then(doTransition);
    } else {
      doTransition();
    }
  }

  if (btn1) btn1.addEventListener('click', handleStep1);
  [nameInput, emailInput].forEach(function (el) {
    if (el) el.addEventListener('keydown', function (e) { if (e.key === 'Enter') handleStep1(); });
  });

  // ── Step 2: Phone (optional) ───────────────────────────────────────────────

  function handleStep2() {
    var phone  = phoneInput ? phoneInput.value.trim() : '';
    var digits = phone.replace(/\D/g, '');
    if (err2) err2.textContent = '';

    if (digits.length < 10) {
      if (err2) err2.textContent = 'Enter a valid 10-digit number.';
      return;
    }

    if (btn2) { btn2.disabled = true; btn2.textContent = '—'; }

    gtagEvent('gate_step2_submitted');
    var formattedPhone = formatPhone(phone);

    if (publicKey) {
      // Include the email from step 1 so Klaviyo merges into one profile
      var attrs = {
        phone_number: formattedPhone,
        subscriptions: { sms: { marketing: { consent: 'SUBSCRIBED' } } },
      };
      if (window._pgEmail) attrs.email = window._pgEmail;
      if (window._pgName)  attrs.first_name = window._pgName;

      klaviyoSubscribe(attrs, smsListId || listId).then(function () {
        klaviyoPush(['identify', { $phone_number: formattedPhone }]);
        klaviyoPush(['track', 'Gate Phone Submitted']);
        showSuccess();
      });
    } else {
      klaviyoPush(['track', 'Gate Phone Submitted']);
      showSuccess();
    }
  }

  if (btn2) btn2.addEventListener('click', handleStep2);
  if (phoneInput) phoneInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') handleStep2(); });

  // ── Skip phone ─────────────────────────────────────────────────────────────

  if (skipBtn) skipBtn.addEventListener('click', function () {
    gtagEvent('gate_step2_skipped');
    klaviyoPush(['track', 'Gate Phone Skipped']);
    showSuccess();
  });

  // ── VIP toggle ─────────────────────────────────────────────────────────────

  if (vipToggle && vipWrap) {
    vipToggle.addEventListener('click', function () {
      var isOpen = !vipWrap.classList.contains('is-hidden');
      vipWrap.classList.toggle('is-hidden', isOpen);
      vipToggle.setAttribute('aria-expanded', String(!isOpen));
      if (!isOpen) { var pw = vipWrap.querySelector('input[type="password"]'); if (pw) pw.focus(); }
    });
  }

})();
